export default "__VITE_ASSET__8ad07a58__"